/* eslint-disable no-undef */


import React, { useEffect, useState } from 'react';
import utils from 'utils';
import { StepBody, Paragraph, Center, ButtonLink } from 'meitav-uikit';
import { Parser } from 'html-to-react';
import * as Constants from "../../utils/constants";
import { Row } from 'react-bootstrap';
import './footer.css'
const { UmbracoUtills, rest } = utils;

const Footer = props => {
  const p = new Parser();


  return (
      <Row className="footer">
        <Paragraph align="center">{props.text}</Paragraph>
      </Row>
  );
}

export default Footer;
